import { operatorService } from '../../_services'
import { router } from '@/_helpers/index'
import { localStore } from '@/_utils/localstore'

const currentUser = JSON.parse(localStore.getItem('user') as string)

const initialState = currentUser
  ? { status: { loggedIn: true }, currentUser, messages: {} }
  : { status: {}, user: null, messages: {} }

export const authentication = {
  namespaced: true,
  state: initialState,
  actions: {
    login({ dispatch, commit }: any, { username, password }: any) {
      commit('LOGIN_REQUEST', { username })

      return operatorService.login(username, password).then(user => {
        commit('LOGIN_SUCCESS', user)
        router.push('/home')
      }).catch((errorMsg) => {
        commit('LOGIN_FAILURE', errorMsg)
      })
    },
    logout({ commit }: any) {
      operatorService.logout()
      commit('LOGOUT')
    },
  },
  mutations: {
    LOGIN_REQUEST(state: any, user: any) {
      state.status = { loggingIn: true }
      state.operator = user
    },
    LOGIN_SUCCESS(state: any, response: any) {
      state.status = { loggedIn: true }
      state.messages = { info: [response.message] }
      state.operator = response.data
    },
    LOGIN_FAILURE(state: any, errorMsg: any) {
      state.status = { loggingIn: false }
      state.messages = { error: [errorMsg] }
      state.operator = null
    },
    LOGOUT(state: any) {
      state.status = {}
      state.operator = null
    }
  }
}
